// extracted by mini-css-extract-plugin
module.exports = {"cover":"whyWeDoIt_cover__1MpvM","image":"whyWeDoIt_image__16qUu","capitals":"whyWeDoIt_capitals__8wNRl","title":"whyWeDoIt_title__4Px8K"};